'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _util = require('../vendor/util');

var _Header = require('./UI/Header.jsx');

var _Header2 = _interopRequireDefault(_Header);

var _browser = require('../containers/browser.js');

var _browser2 = _interopRequireDefault(_browser);

var _Tasks = require('./Tasks/Tasks.jsx');

var _Tasks2 = _interopRequireDefault(_Tasks);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import db from '../db'

var App = function App() {
  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(_Header2.default, null),
    (0, _preact.h)(
      'div',
      { 'class': 'columns' },
      (0, _preact.h)(_browser2.default, null),
      (0, _preact.h)(_Tasks2.default, null)
    )
  );
};

exports.default = App;


//////////////////
// WEBPACK FOOTER
// ./client/components/App.jsx
// module id = 67
// module chunks = 0